export default {
  openButton: 'Generate with AI',
  openButtonFill: 'Complete {entity} with AI',
  title: 'Generate {entity} with AI',
  subtitleSetup: 'Step 1 of 2 · Choose the scale and which criteria get written',
  subtitleReview: 'Step 2 of 2 · Review the matrix before creating it',
  close: 'Close',
  back: 'Back',

  // Step 1
  fromDesign: 'From the Instructional Design: "{piece}"',
  titleLabel: 'Rubric name',
  titlePlaceholder: 'E.g. Case report rubric',
  presetLabel: 'Rubric Model',
  levelsSummary: '{count} levels:',
  levelsMissing:
    'This Rubric Model has no performance levels, so there are no cells to write.',
  themeLabel: 'Topic or focus (optional)',
  themePlaceholder: 'E.g. assess against the cold chain report',
  themeHint: 'Guides what the criteria are framed around',
  themeInfo:
    'Narrows the context of the criteria, without changing what they measure: the concrete product being assessed, a scenario or an emphasis. E.g. "on the written report", "during the workshop performance". It is not a place to give instructions.',
  criteriaTitle: 'Criteria ({entity})',
  criteriaHint:
    'One dimension per row, with the {entity} it measures: an integrative dimension can measure several. What the AI writes is the criterion and the cells for each level; the levels and the weights are not decided by the AI.',
  colWeighing: 'Weight',
  addRow: 'Add a dimension',
  removeRow: 'Remove the dimension',
  rowsEmpty: 'There are no dimensions. Add one and choose which Indicators it measures.',
  distribute: 'Split 100% among the dimensions',
  weighingTotal: 'Total: {total}%',
  weighingOfCriteria: 'Up to {total}%',
  weighingExisting: '{count} dimensions already weigh {total}%',

  // Step 2
  streaming: 'Writing... {done} of {total} criteria',
  reviewHint:
    '{count} proposed criteria. Nothing has been saved yet: discard the ones that do not work and create the rest.',
  reviewEmpty: 'No criteria left to review.',
  discard: 'Discard',
  restore: 'Restore',

  // Actions
  generate: 'Generate {count}',
  save: 'Create the Rubric with {count} criteria',
  saveFill: 'Add {count} criteria',
  saved: '{count} criteria were saved.',
  savingProgress: 'Saving... {done} of {total}',

  // Errors
  generateError:
    'An error occurred while generating the rubric with AI. Please try again.',
  generateEmpty:
    'The AI did not propose any complete criterion. A criterion missing a cell is discarded: a rubric with an empty box cannot be used to assess. Please try again.',
  noCriterias:
    'This evaluation does not declare any {entity}, which is what the criteria are meant to measure. Declare them in the Instructional Design and try again.',
}
